import { Classes, NonIdealState } from "@blueprintjs/core";
import { DataTable, IDataTableProps } from "nsitools-react";
import * as React from "react";
import styled from "styled-components";

import { useTl } from "../../hooks";
import { ETLCodes } from "../../locales";

export interface IDrupalDataTableProps<T> extends IDataTableProps<T> {
  searched?: boolean;
}

const Container = styled.div`
  & .${Classes.HTML_TABLE_STRIPED} tbody tr:nth-child(odd) td {
    background: rgba(53, 161, 227, 0.1) !important;
  }

  & td {
    vertical-align: middle !important;
  }

  .datatable-filter-input input {
  }
`;

const StyledNonIdealState = styled(NonIdealState)`
  padding-bottom: 1rem;
  & > .${Classes.HEADING} {
    color: rgba(92, 112, 128, 0.6) !important;
  }
`;

export function DrupalDataTable<T>(props: IDrupalDataTableProps<T>) {
  const { searched } = props;
  const { t } = useTl();
  return (
    <Container>
      <DataTable
        largeFilter={true}
        htmlTableOptions={{
          compact: true,
          striped: true,
        }}
        filterMode="OnEnter"
        dateFormat="dd/MM/yyyy"
        renderNoData={
          searched || searched === undefined ? (
            <StyledNonIdealState icon="search" title={t(ETLCodes.GeneralNoData)} />
          ) : (
            <StyledNonIdealState icon="series-search" title={t(ETLCodes.PleaseSelectCriteria)} />
          )
        }
        {...props}
      />
    </Container>
  );
}
